import { z } from "zod";

/**
 * Notes are kept per store and filter config, not per output_store_pog row, so every version
 * of a store's POG (Save New Version, flow updates) reads and writes the same note.
 */
export const RouteMerchflowStorePog_storePogId_Notes = "/merchflow/store/pog/:storePogId/notes";

export const STORE_POG_NOTES_MAX_LENGTH = 5000;

export const ParamsMerchflowStorePog_storePogId_NotesSchema = z.object({
  storePogId: z.coerce.number().int().positive(),
});

export const PayloadPutMerchflowStorePog_storePogId_NotesSchema = z.object({
  notes: z.string().max(STORE_POG_NOTES_MAX_LENGTH),
});

export const ResponseMerchflowStorePog_storePogId_NotesSchema = z.object({
  notes: z.string(),
  /** Null when no one has saved a note for this POG yet. */
  updatedAt: z.string().nullable(),
  updatedByName: z.string().nullable(),
});

export type ParamsMerchflowStorePog_storePogId_Notes = z.infer<
  typeof ParamsMerchflowStorePog_storePogId_NotesSchema
>;
export type PayloadPutMerchflowStorePog_storePogId_Notes = z.infer<
  typeof PayloadPutMerchflowStorePog_storePogId_NotesSchema
>;
export type ResponseMerchflowStorePog_storePogId_Notes = z.infer<
  typeof ResponseMerchflowStorePog_storePogId_NotesSchema
>;
